<template>
  <div>
    <canvas id="canvas" width="1000" height="600"></canvas>
  </div>
</template>

<script>
const WordCloud = require('../assets/wordcloud2.js')

import { db } from '../main'
import wordcloud_dict from '../assets/wordcloud-dict.js'

export default {
  name: 'WordCloud',
  data() {
    return {
      rawcloud: {},
    }
  },
  watch: {
    rawcloud: function(rawCloud, oldCloud) {
      console.log(rawCloud);
      console.log('total:' + rawCloud['total'])
      if (rawCloud == null) {
        console.log("rawcloud is empty")
        return;
      }
      var array = [];
      for (var key in rawCloud) {
        if (rawCloud.hasOwnProperty(key)) {
        if (key == 'total') continue;
        console.log(rawCloud[key]);
        array.push([wordcloud_dict[key], rawCloud[key]/rawCloud['total']*12])
        }
      }
      console.log(WordCloud.isSupported);
      var canvas = document.getElementById('canvas')
      console.log(canvas.width);
      WordCloud(document.getElementById('canvas'), {
        list: array,
        gridSize: 3,
        weightFactor: 7,
        fontFamily: 'Microsoft YaHei, serif',
        rotateRatio: 0.5,
        rotationSteps: 2,
      })
    }
  },
  firestore() {
    return {
      rawcloud: db.collection("enow-cloud").doc("LnLHuCUUzFihi4Ni80yn"),
    }
  }
}
</script>


<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC');

#canvas {
  padding: 20px;
  margin: auto;
}

button {
  float: right;
  margin: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/WordCloud.vue